import { GovDropdown } from '@gov-design-system-ce/react';
import type { DatovkaApiType } from '@gov-nx/api';
import { DataBoxRecipientDetailContent } from '@gov-nx/ui/web';
import { useBoolean } from '@gov-nx/utils/common';

interface DataBoxMessageDataBoxDetailProps {
	dataBox: DatovkaApiType;
	label: string;
	position?: 'left' | 'right';
}

export const DataBoxMessageDataBoxDetail = ({
	dataBox,
	label,
	position,
}: DataBoxMessageDataBoxDetailProps) => {
	const showDetail = useBoolean(false);

	return (
		<GovDropdown
			color="primary"
			size="s"
			type="link"
			onChange={() => showDetail.setTrue}
			aria-label={label}
			open={showDetail.value}
			position={position}
			className="ds-bussines-card"
			label={label}>
			<DataBoxRecipientDetailContent dataBox={dataBox} />
		</GovDropdown>
	);
};
